// assets
import { IconBuilding, IconUserPlus, IconPuzzle, IconKey, IconUserCheck } from '@tabler/icons';

// constant
const icons = { IconBuilding, IconUserPlus, IconPuzzle, IconKey, IconUserCheck };

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

const administrator = {
  id: 'administrator',
  title: 'Administrator',
  icon: icons.IconKey,
  type: 'group',
  children: [
    {
      id: 'admins',
      title: 'Admins',
      type: 'item',
      url: '/administrator/admins',
      icon: icons.IconUserCheck,
      breadcrumbs: false
    },
    {
      id: 'academies',
      title: 'Academies',
      type: 'item',
      url: '/administrator/academies',
      icon: icons.IconBuilding,
      breadcrumbs: false
    },
    {
      id: 'students-bulk',
      title: 'Students (Bulk)',
      type: 'item',
      url: '/administrator/students-bulk',
      icon: icons.IconUserPlus,
      breadcrumbs: false
    },
    {
      id: 'questions-bulk',
      title: 'Questions (Bulk)',
      type: 'item',
      url: '/administrator/questions-bulk',
      icon: icons.IconPuzzle,
      breadcrumbs: false
    }
  ]
};

export default administrator;
